import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import {
  Breakpoint,
  DESKTOP_TOTAL_HEIGHT,
  MOBILE_TOTAL_HEIGHT,
} from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex(),
    flexDirection: 'column',
    width: '100%',
    padding: '0 15px',

    minHeight: `calc(100vh - ${DESKTOP_TOTAL_HEIGHT}px)`,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      minHeight: `calc(100vh - ${MOBILE_TOTAL_HEIGHT}px)`,
    },
  },
  wrap: {
    ...dFlex('flex-start', 'center'),
    flexDirection: 'column',
    gap: 20,
  },
}));

export default useStyles;
